import { Global, css } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';
import { Fragment } from 'react';

const globalStyle = ({ global }) => global;

export const GlobalMapUIStyle = () => (
  <Fragment>
    <Global
      styles={css`
        ${emotionNormalize}
      `}
      key="normalize"
    />
    <Global styles={globalStyle} key="global" />
  </Fragment>
);
